import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import throttle from 'lodash.throttle';

import { fetchEvents } from '../../state/actions';

import EventSearchNameInner from './inner';

const getSearchByNameQuery = (query, displayMax, countryCode) => ({
  name: query,
  pastevents: countryCode !== 'US',
  resultsPerPage: displayMax,
});

class EventSearchNameContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayMax: 3,
      query: '',
    };
  }

  fetchData = (append = false) => {
    const { displayMax, query } = this.state;
    if (query.length >= displayMax) {
      const { countryCode, dispatchFetchEvents } = this.props;
      dispatchFetchEvents(getSearchByNameQuery(query, displayMax, countryCode), append);
    }
  }

  throttledFetchData = throttle(this.fetchData, 1000);

  handleChange = (event) => {
    this.setState({
      query: event.target.value,
    }, this.throttledFetchData);
  }

  clearQuery = () => {
    this.setState({ query: '' });
  }

  render() {
    const { query, displayMax } = this.state;
    const { countryCode, onEsc, onSelect, searchingByName, toggleField } = this.props;
    return (
      <EventSearchNameInner
        onEsc={onEsc}
        clearQuery={this.clearQuery}
        onChange={this.handleChange}
        toggleField={toggleField}
        searchingByName={searchingByName}
        onSelect={onSelect}
        value={query}
        query={getSearchByNameQuery(query, displayMax, countryCode)}
        {...this.props}
      />
    );
  }
}

EventSearchNameContainer.propTypes = {
  /*
   * The code representing the country in which the session is taking place
   */
  countryCode: PropTypes.string,
  /**
   * Dispatch method to fetch more events for current list
   */
  dispatchFetchEvents: PropTypes.func.isRequired,
  /*
   * Function to quit search container if ESC key pressed.
   */
  onEsc: PropTypes.func,
  /*
   * Callback function called when event is selected.
   */
  onSelect: PropTypes.func,
  /*
   * Boolean to determine whether component is searching by name.
   */
  searchingByName: PropTypes.bool,
  /**
   * Function to toggle display of search fields.
   */
  toggleField: PropTypes.func,
};

EventSearchNameContainer.defaultProps = {
  countryCode: undefined,
  onEsc: () => {},
  onSelect: () => {},
  toggleField: () => {},
  searchingByName: false,
};

// Shorthand object definition, maps action creator to dispatch
const mapDispatchToProps = {
  dispatchFetchEvents: fetchEvents,
};

const mapStateToProps = state => ({
  countryCode: state.countryCode,
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventSearchNameContainerWithRedux = connect(mapStateToProps, mapDispatchToProps)(EventSearchNameContainer);  // eslint-disable-line no-class-assign, max-len

export default EventSearchNameContainerWithRedux;



// WEBPACK FOOTER //
// ./app/src/containers/EventSearchName/index.jsx